export default __webpack_public_path__ + "static/char-61-anr-6dcedd298968843f2f189707b03074d7.webp";